// extracted by mini-css-extract-plugin
export default {"text":"Rules_text__n2i9h","subText":"Rules_subText__IR2cp","noIndent":"Rules_noIndent__uRUka","divider":"Rules_divider__M+Buf"};